import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/state/store';

import '@/plugins/axios';
import '@/plugins/buefy';
import '@/plugins/firebase';
import '@/plugins/vcalendar';
import '@/plugins/loadScript';
import { firebase, auth } from '@/plugins/firebase';
import { checkSigninDateTime } from '@/services/authServices';

import 'v-credit-card/dist/VCreditCard.css';
import '@/assets/scss/pandora-style.scss';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

// eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
  if (to.meta.skipAuthCheck) {
    next();
    return;
  }

  let closer = auth.onAuthStateChanged(async user => {
    if (user) {
      if (await checkSigninDateTime()) {
        next();
      } else {
        await auth.signOut().catch(err => {
          console.error(err);
        });
        await store.dispatch('live/initStore');
        store.dispatch('auth/signOut');
        next('/signin');
      }
    } else {
      next('/signin');
    }
    closer();
  });
});

new Vue({
  router,
  store,
  // NOTE: fbUser is just an instance of firebase.User type.
  async created() {
    auth.onAuthStateChanged(async fbUser => {
      // set html tag lang attribute to prevent auto translation
      const html = document.documentElement;
      html.setAttribute('lang', 'jp');

      if (!fbUser || this.$route.path.includes('signup')) return;

      // update auth state
      const { uid, email, providerData, emailVerified } = fbUser;
      await store.dispatch('auth/initStore', {
        uid,
        email,
        providerData,
        emailVerified
      });
      await store.dispatch('live/initStore');

      // redirect to user/created if email not verified
      if (!emailVerified && !this.$route.path.includes('signup')) {
        this.$router.push('/user/created');
      }

      // load user doc
      try {
        await store.dispatch('user/loadUserDoc', uid);
        await store.dispatch('doron/loadDoronDoc', uid);
      } catch (err) {
        if (
          err.message === 'User doc not exist' &&
          this.$route.path !== '/signup' &&
          this.$route.path !== '/signin'
        ) {
          // redirect to sign up page if can't load userDoc
          this.$router.push('/signup');
          return;
        }
        if (err.message !== 'User doc not exist') console.error(err);
        return;
      }

      const userState = store.state.user;
      if (userState.userType === 'performer') {
        await store.dispatch('checkIsStreaming', uid);

        // load ivs information if ivsChannel & ivsStreamKey ARN exists
        if (userState.ivsChannelArn && userState.ivsStreamKeyArn) {
          await store.dispatch('ivs/initStore', {
            channelArn: userState.ivsChannelArn,
            streamKeyArn: userState.ivsStreamKeyArn
          });
        }
        // create if ivsChannel & ivsStreamKey ARN notexists
        else {
          await store.dispatch('createChannel', uid);
        }
      }

      store.dispatch('system/ready');
    });
  },
  render: h => h(App)
}).$mount('#app');
